// Rest-of-month scaling for the current calendar month's forecast.
// Mirrors the (now-disabled) adjustment in fetch_predicted_units:
//   days_left = days_in_month - current_day
//   adjustment = days_left / days_in_month

export const getCurrentMonthKey = () => {
  const today = new Date();
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
    2,
    "0"
  )}`;
};

// Remaining share of the calendar month (excluding today, matching backend).
// Returns 1 for every non-current month.
export const getRestOfMonthRemainingFraction = (monthKey) => {
  if (monthKey !== getCurrentMonthKey()) return 1;
  const today = new Date();
  const daysInMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  ).getDate();
  if (daysInMonth <= 0) return 1;
  const daysLeft = daysInMonth - today.getDate();
  return daysLeft / daysInMonth;
};

export const applyRestOfMonth = (monthKey, fullValue) => {
  if (fullValue === "" || fullValue == null || fullValue === undefined) {
    return fullValue;
  }
  const fraction = getRestOfMonthRemainingFraction(monthKey);
  if (fraction >= 1) return Number(fullValue) || 0;
  return Math.round(Number(fullValue) * fraction) || 0;
};

export const formatMonthLabelWithRestOf = (monthKey, options = {}) => {
  const { short = false } = options;
  const [y, m] = String(monthKey).split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  return short
    ? `${d.toLocaleString("en-US", { month: "short" })} ${m}/${String(y).slice(
        -2
      )}`
    : d.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};
